import { ReactElement } from 'react'
import Add from '@mui/icons-material/Add'
import { IconButton, IconButtonProps, SvgIconPropsSizeOverrides } from '@mui/material'
import { OverridableStringUnion } from '@mui/types'

interface Props extends IconButtonProps {
  iconFontSize?: OverridableStringUnion<
    'inherit' | 'large' | 'medium' | 'small',
    SvgIconPropsSizeOverrides
  >
}

const AddButton = ({ iconFontSize = 'small', ...props }: Props): ReactElement => (
  <IconButton {...props}>
    <Add fontSize={iconFontSize} />
  </IconButton>
)

export default AddButton
